import * as socketIo from 'socket.io-client';
 
import { DatabaseService } from 'src/app/shared/services/database.service';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Socket } from 'socket.io-client';
import { environment } from '../../../environments/environment';
import { IncomingCallDialogComponent } from '../dialogs/incoming-call-dialog/incoming-call-dialog.component';
import { ChatDialogComponent } from '../dialogs/chat-dialog/chat-dialog.component';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private clientSocket: Socket;
  public chat: Observable<any>;

  constructor(
    private matDialog: MatDialog,
    private databaseService: DatabaseService,
    private http: HttpClient
  ) {
    this.clientSocket = socketIo.connect(environment.apiURL, {
      transports: ['websocket'],
    });
  }

  public async register(email: string): Promise<void> {
    this.clientSocket.emit('register', email);
  }

  public async openChatWithUser(
    user: any,
    type: string = 'chat',
    isAnswer: boolean = false,
    history: any = [],
    chatId: string = ''
  ): Promise<any> {
    const dialogRef = this.matDialog.open(ChatDialogComponent, {
      data: {
        user: user,
        type: type,
        isAnswer: isAnswer,
        history: history,
        chatId: chatId
      },
    });
  }

  public async incomingCallFrom(user: any) {
    const dialogRef = this.matDialog.open(IncomingCallDialogComponent, {
      data: {
        user: user,
      },
    });

    return dialogRef;
  }

  public async getMessages(
    activeUserEmail: string,
    targetUserEmail: string
  ): Promise<any[]> {
    const messages = await this.databaseService.postRequest(
      { activeUserEmail, targetUserEmail },
      'chat/get_messages'
    );
    return messages;
  }

  public async sendMessage(
    activeUserEmail: string,
    targetUserEmail: string,
    message: string,
    chatId: string | null
  ): Promise<void> {
    await this.databaseService.postRequest(
      { activeUserEmail, targetUserEmail, message, chatId },
      'chat/send_message'
    );
  }

  public initializeChatObservable(
    activeUserEmail: string,
    targetUserEmail: string
  ): void {
    this.chat = new Observable((subscribe) => {
      this.clientSocket.on(
        `chat_update_${activeUserEmail}_${targetUserEmail}`,
        (data) => {
          subscribe.next(data);
        }
      );
    });
  }

  public createVideoCall(
    activeUserEmail: string,
    targetUserEmail: string
  ): void {
    this.clientSocket.emit('create_video_call', {
      activeUserEmail: activeUserEmail,
      targetUserEmail: targetUserEmail,
    });
  }

  public emit(event: string, data: any): void {
    this.clientSocket.emit(event, data);
  }

  public on(event: string, callback: (data: any) => void): void {
    this.clientSocket.on(event, callback);
  }

  public off(event: string): void {
    this.clientSocket.off(event);
  }

  public async getChats(userId) {
    return this.databaseService.getRequest(`chat/get_chats/${userId}`);
  }

  public async getChatMessages(chatId) {
    return await this.http.get(`http://127.0.0.1:7678/chat/${chatId}/messages`).toPromise();
  }
}
